<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">会员排行</div>
           
           
             <!-- table组件 -->
            <div class="my_table  ">
               <Header class="my_title txt_l  my_title_bottom">
                   <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                        会员排行
                   </span>
                    <div class="ct_rgt">
                        <div class="sta_btn  sb_e">
                            <Row>
                                
                                <Col span="12">
                                    <DatePicker split-panels @on-change='dateFun' v-model="date" type="daterange"  placement="bottom-end" placeholder="请选择时间"    clearable   style="width: 200px"></DatePicker>
                                </Col>
                            </Row>
                                            </div>
                        <div :class="[type == 2?'time_active':''] " class="sta_btn  sb_d"  @click="btnFun(2)">最近90天</div>
                        <div :class="[type == 1?'time_active':''] " class="sta_btn  sb_c"  @click="btnFun(1)">最近30天</div>
                        <div :class="[type == 0?'time_active':''] " class="sta_btn  sb_b"  @click="btnFun(0)">全部</div>
                        <div class="sta_btn  sb_a" type="primary"   @click="exportData">导出数据</div>
                        
                        
                        
                        
                    </div>
                </Header>
                <Table border :columns="columns1" :data="data1" ref='table'>
                    
                   
                    
                </Table>
                <Footer>
                    <Page  :current.sync="page" :total="toatalPage" :page-size='pageSize'    @on-change='changepage'  show-total  show-elevator />
                </Footer>
                
              
            </div>

       </div>
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';

    export default {
        name:'list',
        data () {
            return {
                token:'',
                // 搜索
                type :0,
                time_star:'',
                time_end:'',
                date:'',
                time:'',

                // table
                total:null,
                columns1:[],
                data1:[],
                toatalPage:0,
                page:1,
                pageCurrent:1,
                pageSize:20,

               

                options2: {
                    shortcuts: [
                        {
                            text: '1 week',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '1 month',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '3 months',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                },
              
            }
        },
       
        watch:{
            type(val,old){
                var that = this;
                that.load(1);
            }
        },
        computed: {
          
            
        },
        methods: {
           load(btn){
                var that = this;
                 // vuex
                that.token = that.$store.state.token;


                // if(type != 3){
                //     url = 'account/service/admin/finance/statistics?type='+that.type
                // }else{
                //     url = 'account/service/admin/finance/statistics?type=3&beginTime='+that.time_star+'&endTime='+ that.time_end
                // }
                var url;
                var mUrl = 'account/service/admin/finance/member/ranking?';
                //  0是关闭和初始,1是搜索框，2是分页
                if(btn == 0){
                    url = mUrl+'page=1&type=0';  //初始化
                }else if(btn == 1){
                    if(that.type != 3){
                        url = mUrl+'page=1&type='+that.type;  //提交type  
                    }else{
                        url = mUrl+'page=1&type=3&beginTime='+that.time_star+'&endTime='+ that.time_end ;
                    }
                       
                }else if(btn == 2){
                  
                    if(that.type != 3){
                        url = mUrl+'page='+that.page+'&type='+that.type;  //提交type  
                    }else{
                        url = mUrl+'page='+that.page+'&type=3&beginTime='+that.time_star+'&endTime='+ that.time_end ;
                    }
                }

               
                that.$ajax({
                
                    method:'get',
                    url: url,
                    data: {},
                   
                }).then(res => {
                        
                    var total = res.data.data;
                    var list =res.data.data.list;
                    
                    that.total = total;
                    var len = list.length;
                    
                        
                    that.columns1 = [
                        {title:'排行',key:'user_guid',align:'center',width:80},
                        {title:'UID码',key:'number',align:'center'},
                        {title:'账号',key:'mobile',align:'center'},
                        {title:'会员昵称',key:'name',align:'center'},
                        {title:'订单数(单位:个)',key:'count',align:'center'},
                        {title:'购买金额',key:'sum',align:'center'}
                       
                        
                        
                    ];

                   
                    
                    for(var i=0;i<len;i++){
                        // 排行
                        list[i].user_guid = i+1;
                        //  消费金额 
                        list[i].sum = '￥'+ (list[i].sum/100).toFixed(2);
                        
                        
                            
                        
                    }

                    that.data1 = list;

                    that.toatalPage = total.total;
                    that.pageSize = total.pageSize;
                    
                    
                   
                }).catch(err=>{
                    console.log(err)
                })

              
           },
           changepage(index){
               var that = this;
              
               that.load(2);
           },
            //    选择日期范围
           dateFun(data){
               var that = this;
               that.time_star = data[0];
               that.time_end = data[1];
               if(that.time_star != ''){
                   that.type = 3;
               }
        
               
           },

            // 选择其他改type
           btnFun(data){
               var that = this;
               that.type = data;
               that.date = '';
               
           },

            

           //导出数据
           //    导出
            exportData(){
                var that = this;
                that.$refs.table.exportCsv({
                    filename: '会员排行',
                    original: true
                });
               
            },



             
            
        },
        mounted: function(){
           var that = this;
           that.checkGuid = that.$store.state.checkGuid;
           that.load(0);
            
        }
    }
</script>
<style scoped>
    



    .table table{
      width: 100% !important;
    }
    
    
   .ct_rgt{
        width: auto;
        height: 100%;
        float: right;
    }
    .ct_rgt .sta_btn{
        float: right;
        width: 88px;
        height: 30px;
        line-height: 28px;
        margin-top: 14px;
        text-align: center;
        /* background: #1abc9c; */
        border: 1px solid #ccc;
    }
    .ct_rgt .sb_a{
        margin-right: 10px;
    }
    .ct_rgt .sb_b{
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-right: 0;
    }
    .ct_rgt .sb_d{
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: 0;
        margin-right: 10px;
    }
    .ct_rgt .sb_e{
        position: relative;
        
        width: auto;
        background: transparent;
        border: none;
    }
    .ct_rgt .time_active{
        background: #1abc9c;
        border-color:#1abc9c;
        color: white;
    }
    
</style>



